<template>
  <div id="ExhibitionPc">
    <div class="main_bg">
      <!-- KV -->
      <div class="banner">
        <img class="image" src="../../assets/exhibition-sh/imgs/kv1@2x.png" />
      </div>

      <!-- 列表 -->
      <div class="main2-content" style="padding-top: 6rem">
        <div class="layout-flex-map">
          <div class="layout-flex-1">
            <div class="layout-flex-1-img">
              <img class="image" :src="workspace4[0].imgurl" />
            </div>
            <div class="detail-title" style="margin-top: 3rem">
              {{ workspace4[0].title }}
            </div>
            <div class="detail-content-left">
              {{ workspace4[0].content }}
            </div>
            <div class="btn" @click="handleDetail(workspace4[0].url)">
              <!-- 查看详情<span style="padding-left: 20px">→</span> -->
            </div>
          </div>
          <div class="layout-flex-2">
            <div
              class="layout-flex-2-content"
              v-for="(item, index) in workspace4"
              :key="index"
            >
              <template v-if="index">
                <div class="layout-flex-2-img">
                  <img class="image" :src="item.imgurl" />
                </div>
                <div class="layout-flex-2-right">
                  <div class="detail-title">{{ item.title }}</div>
                  <div class="detail-btn" @click="handleDetail(item.url)">
                    查看详情<span style="padding-left: 5px">></span>
                  </div>
                </div>
                <div class="line" v-if="index !== 3"></div>
              </template>
            </div>
          </div>
        </div>
      </div>

      <!-- 亮点车型 -->
      <div class="main2-content" style="padding-top: 6rem">
        <div class="title t1">亮点车型</div>
        <div
          class="layout-flex"
          v-for="(item, index) in workspace5"
          :key="index"
          :style="{ flexDirection: index % 2 ? 'row' : 'row-reverse' }"
        >
          <div class="layout-flex-1">
            <div class="detail-title">{{ item.title }}</div>
            <div class="detail-content">{{ item.content }}</div>
            <div class="detail-btn" @click="handleDetail(item.url)">
              <!-- 查看详情<span style="padding-left: 20px">→</span> -->
            </div>
            <div class="check-btn" @click="handleShiPin(item.videourl)">
              <!-- 实车鉴赏<span style="padding-left: 20px"
                ><i class="el-icon-caret-right"></i
              ></span> -->
            </div>
          </div>
          <div class="layout-flex-2" :class="[index % 2 ? 'mr' : 'ml']">
            <img class="image" :src="item.imgurl" />
          </div>
        </div>
      </div>

      <!-- 现场花絮 -->
      <div class="main2-content bg1" style="padding-top: 6rem">
        <div class="title" style="padding-bottom: 4rem">现场花絮</div>
        <div class="layout-flex-title">
          <div
            class="title-btn"
            v-for="(item, index) in workspace6"
            :key="index"
            :class="{ active: item.key == index6 }"
            @click="handleBtn6(item.key)"
          >
            {{ item.title }}
          </div>
        </div>
        <div>
          <div class="layout-image" :key="index6">
            <div
              v-for="(item, index) in workspace6Item"
              :key="index"
              style="display: inline-block; word-spacing: normal"
            >
              <div class="layout-image-left">
                <div class="layout-image-1">
                  <img
                    class="image"
                    :src="item[0]"
                    @click="handleImg(index * 5 + 0)"
                  />
                </div>
                <div class="layout-image-2">
                  <img
                    class="image"
                    :src="item[1]"
                    @click="handleImg(index * 5 + 1)"
                  />
                </div>
                <div class="layout-image-4">
                  <img
                    class="image"
                    :src="item[3]"
                    @click="handleImg(index * 5 + 3)"
                  />
                </div>
                <div class="layout-image-5">
                  <img
                    class="image"
                    :src="item[4]"
                    @click="handleImg(index * 5 + 4)"
                  />
                </div>
              </div>

              <div
                class="layout-image-right"
                :style="{
                  margin:
                    index + 1 == workspace6Item.length ? '0 0 0 1rem' : '',
                }"
              >
                <div class="layout-image-3">
                  <img
                    class="image"
                    :src="item[2]"
                    @click="handleImg(index * 5 + 2)"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 新车赏析 -->
      <div
        class="main2-content"
        style="padding-top: 6rem; padding-bottom: 4rem"
      >
        <div class="title" style="padding-bottom: 4rem">新车赏析</div>
        <div class="layout-flex-title">
          <div
            class="title-btn"
            v-for="(item, index) in workspace7"
            :key="index"
            :class="{ active: item.key == index7 }"
            @click="handleBtn7(item.key)"
          >
            {{ item.title }}
          </div>
        </div>
        <div class="layout-flex">
          <div class="layout-flex-1">
            <div class="detail-title">{{ workspace7Item[index8].title }}</div>
            <div class="detail-content">
              {{ workspace7Item[index8].content }}
            </div>
            <div
              class="detail-btn"
              @click="handleDetail(workspace7Item[index8].url)"
            >
              <!-- 查看详情
              <span style="padding-left: 20px">→</span> -->
            </div>
            <div>
              <span
                class="arrow-btn"
                :class="{ 'arrow-btn-none': index8Firld }"
                @click="handleLeft"
                >﹤</span
              >
              <span
                class="arrow-btn"
                :class="{ 'arrow-btn-none': index8Last }"
                style="margin-left: 10px"
                @click="handleRight"
                >﹥</span
              >
            </div>
          </div>
          <div class="layout-flex-2">
            <img class="image" :src="workspace7Item[index8].imgurl" />
          </div>
        </div>
      </div>
    </div>

    <!-- 弹框视频播放 -->
    <el-dialog :visible.sync="dialogVisible" v-if="dialogVisible">
      <img class="image" v-if="dialogImg" :src="dialogImg" />
      <contentVideo v-if="dialogVideo" :url="dialogVideo"></contentVideo>
    </el-dialog>
  </div>
</template>

<script>
import contentVideo from "./components/contentVideo.vue";
import config from "./config";
export default {
  components: {
    contentVideo,
  },
  data() {
    return {
      ...config,
      index6: "workspace60",
      index7: "workspace70",
      index8: 0,
      dialogVisible: false,
      dialogImg: "",
      dialogVideo: "",
    };
  },
  computed: {
    workspace6Item() {
      return this[`${this.index6}`];
    },
    workspace6Itembig() {
      return this[`${this.index6}big`];
    },
    workspace7Item() {
      return this[`${this.index7}`];
    },
    index8Firld() {
      return this.index8 === 0;
    },
    index8Last() {
      return this.index8 === this.workspace7Item.length - 1;
    },
  },
  mounted() {
    document.documentElement.style.fontSize =
      document.documentElement.clientWidth / 192 + "px";
  },
  destroyed() {
    document.documentElement.style.fontSize = "62.5%";
  },
  methods: {
    // 详情
    handleDetail(url) {
      window.open(url, "_blank");
    },
    // 实车鉴赏视频
    handleShiPin(url) {
      this.dialogVisible = true;
      this.dialogImg = "";
      this.dialogVideo = url;
    },
    // 图片
    handleImg(index) {
      console.log(index);
      this.dialogVisible = true;
      this.dialogImg = this.workspace6Itembig[index];
      this.dialogVideo = "";
    },
    // 现场花絮按钮
    handleBtn6(key) {
      this.index6 = key;
    },
    // 新车赏析按钮
    handleBtn7(key) {
      this.index7 = key;
      // 重置下标
      this.index8 = 0;
    },
    handleLeft() {
      if (this.index8Firld) return;
      this.index8 = this.index8 - 1;
    },
    handleRight() {
      if (this.index8Last) return;
      this.index8 = this.index8 + 1;
    },
  },
};
</script>

<style lang="less" scoped>
#ExhibitionPc {
  width: 100%;
  min-width: 1200px;
  margin: 0px auto;
  font-size: 14px;
}

// 弹框
/deep/.el-dialog {
  background: transparent;
  box-shadow: none;
  width: 128rem;
  .el-dialog__body {
    padding: 0px;
  }
  .el-dialog__headerbtn {
    top: 0px;
    right: 0px;
  }
  .el-dialog__close {
    color: #fff;
  }
}

//底纹
.main_bg {
  width: 100%;
  min-width: 1200px;
}

//背景图
.banner {
}

// 图片
.image {
  width: 100%;
  display: block;
}

// 布局
.main2-content {
  width: calc(100% - 52rem);
  padding: 0px 26rem;
}

// 大标题
.title {
  color: #333333;
  font-size: 30px;
  font-weight: bolder;
  text-align: center;
}

.t1 {
  position: absolute;
  width: calc(100% - 52rem);
}

// 亮点车型
.layout-flex {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;

  .layout-flex-1 {
    width: 62rem;
  }
  .layout-flex-2 {
    width: 72rem;
  }

  .ml {
    width: 98rem;
    margin-left: -26rem;
  }

  .mr {
    width: 98rem;
    margin-right: -26rem;
  }

  // 详情标题
  .detail-title {
    position: relative;
    display: inline-block;
    font-size: 18px;
    letter-spacing: 1px;
    margin-bottom: 2rem;
    font-weight: bolder;
  }
  .detail-title::after {
    content: "";
    position: absolute;
    bottom: -4px;
    left: 0;
    height: 0.5rem;
    width: 4rem;
    background: #5f84fc;
  }
  // 详情内容
  .detail-content {
    line-height: 22px;
    color: #333333;
    font-size: 13px;
  }
  // 详情按钮
  .detail-btn {
    margin-top: 2rem;
    cursor: pointer;
    width: 18rem;
    height: 4rem;
    background: url("../../assets/exhibition-sh/imgs/btn1@2x.png");
    background-size: 100% 100%;
  }

  .detail-btn:hover {
    background: url("../../assets/exhibition-sh/imgs/btn1a@2x.png");
    background-size: 100% 100%;
  }

  // 实车鉴赏
  .check-btn {
    margin-top: 2rem;
    cursor: pointer;
    width: 18rem;
    height: 4rem;
    background: url("../../assets/exhibition-sh/imgs/btn2@2x.png");
    background-size: 100% 100%;
  }

  .check-btn:hover {
    background: url("../../assets/exhibition-sh/imgs/btn2a@2x.png");
    background-size: 100% 100%;
  }

  .arrow-btn {
    margin-top: 2rem;
    cursor: pointer;
    background: #5f84fc;
    color: #ffffff;
    width: 26px;
    line-height: 30px;
    text-align: center;
    border-radius: 4px;
    display: inline-block;
  }

  .arrow-btn-none {
    opacity: 0.5;
  }
}

// 列表
.layout-flex-map {
  padding-bottom: 6rem;
  width: 100%;
  display: flex;
  justify-content: space-between;

  .layout-flex-1 {
    width: 67rem;
  }
  .layout-flex-2 {
    width: 67rem;
  }

  .layout-flex-1-img {
    width: 67rem;
    height: 36rem;
  }
  .layout-flex-2-content {
    position: relative;
  }
  .layout-flex-2-img {
    position: absolute;
    left: 0;
    top: 0;
    width: 26rem;
    height: 16rem;
  }
  .layout-flex-2-right {
    padding-left: 29rem;
    height: 16rem;
  }
  .detail-title {
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    margin-bottom: 2rem;
  }
  .detail-content-left {
    color: #333333;
    font-size: 12px;
  }
  .detail-content {
    color: #333333;
    font-size: 12px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    overflow: hidden;
  }
  .detail-btn {
    margin-top: 1rem;
    color: #5f84fc;
    cursor: pointer;
  }
  .btn {
    margin-top: 2rem;
    cursor: pointer;
    width: 18rem;
    height: 4rem;
    background: url("../../assets/exhibition-sh/imgs/btn1@2x.png");
    background-size: 100% 100%;
  }
  .line {
    height: 1px;
    background: #f1f1f1;
    margin: 2rem 0;
  }
}

// 标题图片
.layout-flex-title {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  .title-btn {
    color: #ffffff;
    cursor: pointer;
    width: 24rem;
    height: 10rem;
    line-height: 8rem;
    text-align: center;
    background: url("../../assets/exhibition-sh/imgs/btn-bg4a@2x.png");
    background-size: 100% 100%;
  }
  .active {
    background: url("../../assets/exhibition-sh/imgs/btn-bg4@2x.png");
    background-size: 100% 100%;
  }
}

// 现场花絮
.layout-image {
  width: 100%;
  // display: flex;
  // justify-content: center;
  // align-items: center;
  white-space: nowrap;
  overflow-x: auto;

  .layout-image-left {
    line-height: 0;
    display: inline-block;
    width: 87rem;
    white-space: normal;
  }

  .layout-image-right {
    line-height: 0;
    margin: 0 1rem;
    display: inline-block;
    width: 44rem;
    white-space: normal;
  }

  .layout-image-1 {
    display: inline-block;
    width: 58rem;
    height: 24rem;
  }

  .layout-image-2 {
    display: inline-block;
    width: 28rem;
    height: 24rem;
    margin-left: 1rem;
  }

  .layout-image-4 {
    display: inline-block;
    width: 28rem;
    height: 24rem;
    margin-top: 1rem;
  }

  .layout-image-5 {
    display: inline-block;
    width: 58rem;
    height: 24rem;
    margin-left: 1rem;
    margin-top: 1rem;
  }

  .layout-image-3 {
    width: 44rem;
    height: 49rem;
  }
}
//
//.layout-image::-webkit-scrollbar-thumb {
//  background: #5f84fc;
//  border-radius: 0;
//}
//
//.layout-image::-webkit-scrollbar-track {
//  background: rgba(95, 132, 252, 0.2);
//  border-radius: 0;
//}

.bg1 {
  background: url("../../assets/exhibition-sh/imgs/bg1@2x.png");
  background-size: cover;
}

@media screen and (min-width: 1600px) {
  .title {
    font-size: 40px;
  }
  // 亮点车型
  .layout-flex {
    .detail-title {
      font-size: 28px;
    }
    // 详情内容
    .detail-content {
      font-size: 18px;
    }
    // 详情按钮
    .detail-btn {
    }
  }

  // 列表
  .layout-flex-map {
    .detail-title {
      font-size: 20px;
    }
    // 详情内容
    .detail-content {
      font-size: 16px;
    }
    // 详情按钮
    .detail-btn {
    }
  }

  // 标题图片
  .layout-flex-title {
    .title-btn {
      font-size: 20px;
    }
  }
}
</style>
